import React from 'react';
import LoginPageLogo from '../LoginPageLogo';
import styled from 'styled-components';
import { Text, View } from '../../components/ui';
import Head from 'next/head';
import bgJpeg from '../../public/static/login-bg.jpg';
import bgWebp from '../../public/static/login-bg.webp';

const ContentWrap = styled(View)`
  overflow: auto;
  flex: 0 0 auto;
  background-color: #051b30;
`;

const HeroSection = styled(View)`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(
      200deg,
      hsla(0, 0%, 100%, 0),
      rgba(0, 64, 163, 0) 48%
    ),
    linear-gradient(#0000006e, #0000006e), url('${bgJpeg.src}');

  @supports (background-image: url('${bgWebp.src}')) {
    background-image: linear-gradient(
        200deg,
        hsla(0, 0%, 100%, 0),
        rgba(0, 64, 163, 0) 48%
      ),
      linear-gradient(#0000006e, #0000006e), url('${bgWebp.src}');
  }

  @supports (background-image: url('/static/login-bg.avif')) {
    background-image: linear-gradient(
        200deg,
        hsla(0, 0%, 100%, 0),
        rgba(0, 64, 163, 0) 48%
      ),
      linear-gradient(#0000006e, #0000006e), url('/static/login-bg.avif');
  }

  background-position:
    0 0,
    0 0,
    0 0;
  background-size: auto, auto, cover;
  background-repeat: repeat, repeat, no-repeat;
  background-attachment: scroll, scroll, scroll;
  max-height: 100%;
  min-height: 100vh;
`;

const LoginPageWrap = styled(View)`
  display: flex;
  width: 400px;
  max-width: 100%;
  flex-direction: column;
  align-items: stretch;
  background-color: ${(props) => props.theme.colors.neutral.white_50};
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
`;

const LoginLogoArea = styled(View)`
  display: flex;
  width: 100%;
  padding: 30px 20px;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.neutral.gray_500};
`;

const LoginFormWrap = styled(View)`
  display: flex;
  width: 100%;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
`;

const Register = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <main>
    <Head>
      <title>Seaber.io</title>
      <meta name="theme-color" content="#357ee2" />
    </Head>
    <ContentWrap>
      <HeroSection>
        <LoginPageWrap>
          <LoginLogoArea>
            <LoginPageLogo />
          </LoginLogoArea>
          <LoginFormWrap data-testid="signin-page-form">
            {children}
          </LoginFormWrap>
          <View bg="neutral.white_100" alignItems="center" p={4}>
            <Text
              width="100%"
              minHeight={21}
              textAlign="center"
              display="inline-block"
            >
              Need help? Contact{' '}
              <a
                href="mailto:support@seaber.io"
                style={{ textDecoration: 'none', color: '#34373b' }}
              >
                support@seaber.io
              </a>
            </Text>
          </View>
        </LoginPageWrap>
      </HeroSection>
    </ContentWrap>
  </main>
);
export default Register;
